Controller = App.loadClass 'core::Angular/Controller'

class exports.IdentificationController extends Controller
    constructor: (@scope, @transitions, @state, @location, @modal) ->
        $('.leaflet-control-buttongrid').hide()
        @scope.unique_location_name = true
        @scope.validateName = @validateName

        # Redirect if we skipped the starting state
        if not @location.new?
            @state.go '^'
            return

        @scope.repo = @location
        @scope.invalid = @location.invalid
        @scope.saving = false

        # Function Declarations
        @scope.validate = @validate
        @scope.transitionTo = @transitionTo
        @scope.saveLocation = @saveLocation
        @scope.editBinDetails = @editBinDetails

        @transitionStart = @transitions.onStart {}, ($transition) =>
            if $transition.to().name isnt 'grower.buyerlocation.place'
                App.map.removeLayer(@location.feature_group) if @location.feature_group?
                App.map.removeControl(@location.drawControl)


        @scope.$on '$destroy', () =>
            @transitionStart()


    transitionTo: (state_name) =>
        @state.go state_name


    validate: (property, value) =>
        @location.validate(property, value)

    validateName: (name) =>
        @scope.unique_location_name = @location.nameIsUnique(name)


    saveLocation: () =>
        @scope.saving = true
        @location.save(+@state.params.fpcResultId).then (response) =>
            @state.go 'grower.fieldprint.step', {
                id: +@state.params.fpcResultId
                step: +@state.params.step
            }, { reload: 'grower.fieldprint.step' }
